import React from 'react';
import styled from 'styled-components';
import { Container } from '@mui/system';
import { Grid } from '@mui/material';
import { CTA } from '../Common/CTA';
import { LoginButton } from './LogginButton';
import { useAuth } from '../../providers/AuthProvider';

const JoinContainer = styled.section`
  background-image: url('./images/curve-bg.png');
  background-color: var(--primary);
  background-position: bottom center;
  background-repeat: no-repeat;
  background-size: cover;
  padding-bottom: 2.5rem;
  .logoContainer {
    text-align: center;
    img {
      width: 80%;
      max-width: 560px;
    }
  }
`;

export const Join = () => {
  const { REGISTER_EXPIRES } = useAuth();
  return (
    <JoinContainer>
      <Container>
        <Grid container spacing={2}>
          <Grid item sm={2} xs={3} /> 
          <Grid item sm={8} xs={6}>
            <div>
              <img src="./images/header-kids.png" alt="Textura de brinquedos para o Dia das Crianças Eskala" className='img-responsive' />
            </div>
          </Grid>
          <Grid item sm={2} xs={3} align='right' mt={1}>
            <LoginButton drawer='login'/>
          </Grid> 
          <Grid item sm={12} xs={12}>
            <div className='logoContainer'>
              <img src="./images/logo.png" alt="Logo Dia das Crianças Eskala - Diversão Surpresa" />
            </div>
          </Grid>
          <Grid item sm={12} xs={12} mt={2}>
            <div className='logoContainer'>
              { REGISTER_EXPIRES > (new Date().getTime()) ? <CTA drawer='register' /> : <CTA drawer='login'>Entrar</CTA> }
            </div>
          </Grid>
        </Grid>
      </Container>
    </JoinContainer>
  )
}
